
import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { finalize } from "rxjs";
import { AppLayoutComponent } from "../../../shared/components/app-layout/app-layout.component";
import { ButtonComponent } from "../../../shared/components/button/button.component";
import { AuthService } from "../../services/auth.service";
import { SnackBarService } from "../../services/snack-bar.service";

@Component({
    selector: "app-recovery-password",
    imports: [
    ReactiveFormsModule,
    AppLayoutComponent,
    ButtonComponent
],
    templateUrl: "./recovery-password.component.html",
    styleUrl: "./recovery-password.component.scss"
})
export class RecoveryPasswordComponent implements OnInit {
  resetPasswordForm = this.formBuilder.group(
    {
      newPassword: ["", [Validators.required, Validators.minLength(6)]],
      confirmPassword: ["", [Validators.required]],
    },
    { validators: this.passwordsMatch },
  );
  resetPasswordToken: string | null = null;

  controls = this.resetPasswordForm?.controls;

  hideConfirm = true;
  hideNew = true;
  loading = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly route: ActivatedRoute,
    private readonly snackbarService: SnackBarService,
  ) {}

  ngOnInit() {
    // Pegando o reset_password_token da URL de forma síncrona
    this.resetPasswordToken = this.route.snapshot.queryParamMap.get(
      "reset_password_token",
    );
  }

  // Função customizada para garantir que as senhas correspondam
  passwordsMatch(form: FormGroup) {
    const newPassword = form.get("newPassword")?.value;
    const confirmPassword = form.get("confirmPassword")?.value;
    return newPassword === confirmPassword ? null : { mismatch: true };
  }

  onSubmit() {
    if (this.resetPasswordForm.valid) {
      this.loading = true;
      const newPassword = this.resetPasswordForm.get("newPassword")?.value;
      const confirmPassword =
        this.resetPasswordForm.get("confirmPassword")?.value;

      const recoveryRequest = {
        user: {
          reset_password_token: this.resetPasswordToken,
          password: newPassword,
          password_confirmation: confirmPassword,
        },
      };
      this.authService
        .recoveryPassword(recoveryRequest)
        .pipe(finalize(() => (this.loading = false)))
        .subscribe({
          next: () => {
            this.router.navigate(["/password"]);
            this.snackbarService.openSnackBar(
              "Senha Resetada com Sucesso, você já pode acessar sua conta!",
              "Fechar",
              "success",
            );
            setTimeout(() => {
              this.router.navigate(["/"]);
            }, 1000);
          },
          error: (error) => {
            console.error("Erro ao recuperar senha:", error);
            const errorMessage = error.error?.errors[0];

            if (errorMessage === "Reset password token is invalid") {
              this.snackbarService.openSnackBar(
                "Token expirado ou inválido. Solicite um novo e-mail para redefinir sua senha.",
                "Fechar",
                "error",
              );
            } else {
              this.snackbarService.openSnackBar(
                "Erro ao recuperar senha, tente novamente mas tarde!",
                "Fechar",
                "error",
              );
            }
          },
        });
    }
  }
}
